import { WarningOutlined } from '@ant-design/icons';
import { UserTask } from '@hefe/models';
import { colors } from '@hefe/ui';
import { formatDateTime, useUserTaskData } from '@hefe/utils';
import { List, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

interface UserTaskListItemComponentProps {
  userTask: UserTask;
}

export default function UserTaskListItemComponent(
  props: UserTaskListItemComponentProps
) {
  const { userTask } = props;
  const navigate = useNavigate();

  const { title, description } = useUserTaskData(props.userTask);

  const onClick = () => {
    navigate('/user/inventories', { state: { openInventory: 2 } });
  };

  return (
    <List.Item>
      <div
        onClick={() => onClick()}
        style={{ cursor: 'pointer', width: '100%' }}
      >
        <List.Item.Meta
          avatar={<WarningOutlined size={30} />}
          title={title}
          description={
            <Space direction="vertical" size={0}>
              <Typography.Text style={{ color: colors.darkgrey, fontSize: 14 }}>
                {description}
              </Typography.Text>
              <Typography.Text style={{ color: colors.grey, fontSize: 12 }}>
                {formatDateTime(userTask.created_at ?? '')}
              </Typography.Text>
            </Space>
          }
        />
      </div>
    </List.Item>
  );
}
